import { useNavigate } from 'react-router-dom';
import { Dispatch, SetStateAction, SyntheticEvent } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import {
  IDia,
  ISemana,
} from '../../../../Interfaces/IMisRutinas';

import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';


interface Props {
  weeklyRoutines: ISemana[];
  obtenerRutinaEjercicio: (dia: IDia, semana: ISemana) => void;
  setIsOpenModalCalentamiento: Dispatch<SetStateAction<boolean>>;
  expanded : string | false;
  handleChange: (panel: string) => (event: SyntheticEvent, isExpanded: boolean) => void;
}

function GridRutinasMobile({ weeklyRoutines, obtenerRutinaEjercicio, setIsOpenModalCalentamiento, expanded, handleChange }: Props) {
  const navigate = useNavigate();

  // const user : IUserFromStorage = JSON.parse( localStorage.getItem('user')! ); 

  return (
    <div className="rut-container">

      <div className="rut-intro">
        <p className="rut-intro-title">Tus rutinas</p>
        <p className="rut-intro-desc">
          Rutinas organizadas semana por semana para un fácil seguimiento de tu progreso.
        </p>
      </div>

      {weeklyRoutines.map((semana, index) => (
        <div className="rut-week-wrapper" key={index}>
          <Accordion
            defaultExpanded={index === 0}
            sx={{
              boxShadow: 'none',
              background: 'transparent',
              '&:before': { display: 'none' },
              '&.Mui-expanded': { margin: 0 },
            }}
            expanded={expanded === `panel${semana.numeroSemana}-${semana.nivel}`}
            onChange={handleChange(`panel${semana.numeroSemana}-${semana.nivel}`)}
          >
            <AccordionSummary
              sx={{ padding: 0, minHeight: 'unset', '& .MuiAccordionSummary-content': { margin: 0 } }}
            >
              <div className="rut-week-header">
                <span className="rut-week-label">{semana.semana}</span>
                <svg className="rut-week-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </div>
            </AccordionSummary>

            <AccordionDetails sx={{ padding: '0.75rem 0 0' }}>
              {/* Calentamiento */}
              <div
                className="rut-warmup-btn"
                onClick={() => setIsOpenModalCalentamiento(true)}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z"/>
                </svg>
                Calentamiento
              </div>

              {/* Days Grid */}
              <div className="rut-days-grid">
                {weeklyRoutines[index].dias.map((dia, indexDia) => (
                  <div
                    className="rut-day-card"
                    key={indexDia}
                    onClick={() => obtenerRutinaEjercicio(dia, semana)}
                  >
                    <span className="rut-day-label">{dia.diaString}</span>
                    <div className="rut-day-content">
                      <CheckCircleIcon
                        sx={{
                          fontSize: 20,
                          color: dia.estado === '2' ? '#22c55e' : '#d4d4d4',
                        }}
                      />
                      <span className="rut-day-name">{dia.diaNombre}</span>
                    </div>
                  </div>
                ))}
              </div>

              <p className="rut-hint">
                Finaliza tus días de entrenamiento para ir progresando.
                Al completar un día verás <CheckCircleIcon sx={{ fontSize: 16, color: '#22c55e', verticalAlign: 'text-bottom' }} />
              </p>
            </AccordionDetails>
          </Accordion>
        </div>
      ))}

      {/* Cardio Section */}
      <div className="rut-cardio-section">
        <p className="rut-cardio-title">Tu Cardio</p>
        <p className="rut-cardio-desc">
          El complemento ideal para tu entrenamiento.
        </p>
        <button
          className="rut-cardio-btn"
          onClick={() => navigate('/cardioRutinas')}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
            <circle cx="12" cy="12" r="3"/>
          </svg>
          Ver Cardio
        </button>
      </div>
    </div>
  );
}

export default GridRutinasMobile;
